import { useState } from 'react'
import SJCard from '@/components/SJCard'
import SJButton from '@/components/SJButton'
import { postFeedback } from '@/services/user'
import SJRadio from '@/components/SJRadio'
import { useInterval } from 'ahooks'
import './index.less'
import { TextArea, Toast } from 'antd-mobile'
import SJSpace from '@/components/SJSpace'
import { useNavigate } from 'react-router-dom'

const feedbackTypes = [
  { title: '功能缺陷', type: 1 },
  { title: '体验优化', type: 2 },
  { title: '其它问题', type: 3 },
]

const Feedback = () => {
  document.title = '问题反馈'
  const [issueType, setIssueType] = useState(1)
  const [description, setDescription] = useState('')
  const [status, setStatus] = useState(false)
  const [loading, setLoading] = useState(false)

  const onInput = (val: string) => {
    setDescription(val.trim().slice(0, 500))
  }

  const handleClick = (type: number) => {
    setIssueType(type)
  }

  const onSubmit = () => {
    if (loading) return
    if (!description) {
      Toast.show('请输入反馈内容')
      return
    }
    setLoading(true)
    postFeedback({
      issueType,
      description,
    })
      .then(() => {
        setStatus(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <div className="page feedback">
      {!status ? (
        <div className="main">
          <SJSpace height={20} />
          <label className="title">问题反馈</label>
          <div className="types">
            <div className="radio-groups">
              {feedbackTypes.map((item) => (
                <SJRadio
                  key={item.type}
                  checked={item.type === issueType}
                  title={item.title}
                  onClick={() => handleClick(item.type)}
                ></SJRadio>
              ))}
            </div>
          </div>
          <SJCard className="card">
            <TextArea
              className="content"
              showCount
              maxLength={500}
              placeholder="请输入您的问题或意见，我们会根据您的反馈及时优化。如果愿意我们和您取得联系，请留下您的联系方式。"
              // placeholderClass="placeholderClass"
              rows={10}
              value={description}
              onChange={onInput}
            />
            {/* <text className="count">{description.length}/500</text> */}
          </SJCard>
          <div className="btn-fixed">
            <SJButton type="primary" size="large" onClick={onSubmit}>
              提交
            </SJButton>
          </div>
          <SJSpace height={20} />
        </div>
      ) : (
        <SuccessCard />
      )}
    </div>
  )
}

const SuccessCard = () => {
  const navigate = useNavigate()
  const [second, setSecond] = useState(3) // 倒计时 总时间
  const [interval, setInterval] = useState<number | undefined>(1000) // 倒计时 频率
  const [intervalText, setIntervalText] = useState(`返回首页(${second}s)`)

  const goHome = () => {
    navigate(-1)
  }

  useInterval(() => {
    if (second === 1) {
      setSecond(0)
      setInterval(undefined)
      setIntervalText(`返回首页`)
      goHome()
    }
    setSecond(second - 1)
    setIntervalText(`返回首页(${second - 1}s)`)
  }, interval)

  const goIndex = () => {
    setInterval(undefined)
    goHome()
  }

  return (
    <div className="main">
      <SJSpace height={20} />
      <SJCard className="success">
        <img className="icon" src={require('./icon-success.png')} alt="" />
        <div className="title">反馈成功</div>
        <div className="desc">已收到您的宝贵建议，感谢您的反馈！</div>
      </SJCard>
      <div className="btn-fixed">
        <SJButton type="primary" size="large" onClick={goIndex}>
          {intervalText}
        </SJButton>
      </div>
      <SJSpace height={20} />
    </div>
  )
}

export default Feedback
